export default __webpack_public_path__ + "static/media/deposit-delay-bonus-ico.35ce56b4.svg";